let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i0qlB")).then(() => parcelRequire('IARrZ'));